import { BaseMapper } from '../../../shared/mappers/base.mapper';
import { Contact } from '../models/contact.type';

export class ContactMapper extends BaseMapper<Contact> {
   
}
